import React, { useState, useEffect } from "react";
import notify from "devextreme/ui/notify";
import Form, { SimpleItem, GroupItem, Label } from "devextreme-react/form";
import { Button } from "devextreme-react";
import { criarFatorCorretivoDs } from "../../../DataSources";
import ImovelButtonGroup from "../imovelButtonGroup";
import apiAxios from "../../../api-axios";
import UserInfo from "../../../UserInfo";
import ShowError from "../../../AppServices";

const FormEditEdificacao = (props) => {
  const [estado, setEstado] = useState();
  const [fatoresCorretivos, setFatoresCorretivos] = useState([]);

  useEffect(() => {
    const abortController = new AbortController();
    console.log("props:", props);
    criarFatorCorretivoDs()
      .load()
      .then((data) => {
        setFatoresCorretivos(data);
      });

    if (props !== undefined) {
      if (props.match.params.id !== undefined) {
        apiAxios
          .get(
            `imoveis/${UserInfo.getPrefeitura()}/scores/${props.match.params.id
            }/E`
          )
          .then((response) => {
            if (response === undefined) {
              notify("Registro não encontrado.", "error");
              props.history.push("/imoveis");
            } else {
              let fatores = {};
              let natureza = "";
              for (let i = 0; i < response.data.length; i++) {
                let opcaoFator = response.data[i];
                fatores["fat" + opcaoFator.categoriaId] = opcaoFator.opcaoSelecionada;
                natureza = opcaoFator.natureza;
              }
              setEstado({ ...fatores, _uiNatureza: natureza });
            }
          });
      }
    }

    return function cleanup() {
      abortController.abort();
    };
  }, []);

  function cancel() {
    notify("Operação cancelada", "warning");
    props.history.push("/imoveis");
  }

  function save() {
    let opcoesFatores = [];
    console.log(estado);

    fatoresCorretivos
      .filter((fator) => fator.tipo === "E")
      .map((fator) => {
        if (estado["fat" + fator.id]) {
          opcoesFatores.push({
            categoriaId: fator.id,
            opcaoSelecionada: estado["fat" + fator.id],
          });
        }
      });

    const entidade = {
      prefeituraId: UserInfo.getPrefeitura(),
      imovelId: props.match.params.id,
      scores: opcoesFatores,
      tipo: "E",
    };
    apiAxios
      .put("/imoveis/inserirfatores", entidade)
      .then((response) => {
        if (response.status === 200) {
          notify("Fatores inseridos com sucesso.", "success", 1000);
        }
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          ShowError(error.response.data.erros);
        } else {
          ShowError(error.message);
        }
        notify(error, "error", 2000);
      });
  }

  function criarLookupFator(fator) {
    let fatorOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      placeholder: "Escolher...",
      dataSource: fator.opcoes,
      showClearButton: true,
      valueExpr: "id",
      displayExpr: "descricao",
    };

    return (
      <SimpleItem
        key={fator.id}
        dataField={"fat" + fator.id}
        editorType={"dxSelectBox"}
        editorOptions={fatorOptions}
      >
        <Label text={fator.descricao} />
      </SimpleItem>
    );
  }

  let _uiNatureza = "";

  if (estado != undefined) {
    _uiNatureza = estado._uiNatureza;
  }

  return (
    <React.Fragment>
      <div className={"content-block dx-card responsive-paddings"}>
        <ImovelButtonGroup props={{ ...props, _uiNatureza: _uiNatureza }} />
        <form>
          <h3>Fatores Corretivos de Edificação</h3>
          <Form formData={estado} colCount={3}>
            <GroupItem colSpan={3} colCount={2}>
              {fatoresCorretivos.length > 0
                ? fatoresCorretivos
                  .filter((x) => x.tipo === "E")
                  .map((x) => criarLookupFator(x))
                : []}
            </GroupItem>
          </Form>
          <div
            style={{
              display: "flex",
              marginTop: "25px",
              justifyContent: "center",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
            }}
          >
            <div style={{ display: "inline-block", marginRight: "10px" }}>
              <Button text="Fechar" onClick={() => cancel()} width={120} />
            </div>
            <div style={{ display: "inline-block", marginRight: "10px" }}>
              <Button
                width={120}
                text="Salvar"
                type="success"
                onClick={() => save()}
              />
            </div>
          </div>
        </form>
      </div>
    </React.Fragment>
  );
};

export default FormEditEdificacao;
